/**
 * Route for `advertiser-payout-rules`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserPayoutRulesPage } from "../features/advertiser-payout-rules/AdvertiserPayoutRulesPage";

export const advertiserPayoutRulesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-payout-rules",
	component: AdvertiserPayoutRulesPage,
});

export default advertiserPayoutRulesRoute;
